module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BreadcrumbFirstItem":{"text":"E-shop"}},"de":{"BreadcrumbFirstItem":{"text":"E-shop"}},"sk":{"BreadcrumbFirstItem":{"text":"E-shop"}}}')
  delete Component.options._Ctor
}
